/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { ApiEvent, ApiEventFromJSON, ApiEventFromJSONTyped, ApiEventToJSON } from './ApiEvent';
import {
  ApiMetadata,
  ApiMetadataFromJSON,
  ApiMetadataFromJSONTyped,
  ApiMetadataToJSON,
} from './ApiMetadata';
import {
  ApiMicroInteractionEligibility,
  ApiMicroInteractionEligibilityFromJSON,
  ApiMicroInteractionEligibilityFromJSONTyped,
  ApiMicroInteractionEligibilityToJSON,
} from './ApiMicroInteractionEligibility';
import {
  ApiMicroInteractionPet,
  ApiMicroInteractionPetFromJSON,
  ApiMicroInteractionPetFromJSONTyped,
  ApiMicroInteractionPetToJSON,
} from './ApiMicroInteractionPet';
import {
  ApiMicroInteractionStepsInner,
  ApiMicroInteractionStepsInnerFromJSON,
  ApiMicroInteractionStepsInnerFromJSONTyped,
  ApiMicroInteractionStepsInnerToJSON,
} from './ApiMicroInteractionStepsInner';

/**
 *
 * @export
 * @interface ApiMicroInteraction
 */
export interface ApiMicroInteraction {
  /**
   *
   * @type {number}
   * @memberof ApiMicroInteraction
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof ApiMicroInteraction
   */
  priority?: number;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteraction
   */
  status?: ApiMicroInteractionStatusEnum;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteraction
   */
  comment?: string;
  /**
   *
   * @type {boolean}
   * @memberof ApiMicroInteraction
   */
  isEligible?: boolean;
  /**
   *
   * @type {string}
   * @memberof ApiMicroInteraction
   */
  apiStatus?: string;
  /**
   *
   * @type {ApiMicroInteractionPet}
   * @memberof ApiMicroInteraction
   */
  pet?: ApiMicroInteractionPet;
  /**
   *
   * @type {ApiMicroInteractionEligibility}
   * @memberof ApiMicroInteraction
   */
  eligibility?: ApiMicroInteractionEligibility;
  /**
   *
   * @type {ApiEvent}
   * @memberof ApiMicroInteraction
   */
  event?: ApiEvent;
  /**
   *
   * @type {Array<ApiMicroInteractionStepsInner>}
   * @memberof ApiMicroInteraction
   */
  steps: Array<ApiMicroInteractionStepsInner>;
  /**
   *
   * @type {ApiMetadata}
   * @memberof ApiMicroInteraction
   */
  metadata?: ApiMetadata;
}

/**
 * @export
 */
export const ApiMicroInteractionStatusEnum = {
  Draft: 'DRAFT',
  Published: 'PUBLISHED',
  Closed: 'CLOSED',
} as const;
export type ApiMicroInteractionStatusEnum = typeof ApiMicroInteractionStatusEnum[keyof typeof ApiMicroInteractionStatusEnum];

export function ApiMicroInteractionFromJSON(json: any): ApiMicroInteraction {
  return ApiMicroInteractionFromJSONTyped(json, false);
}

export function ApiMicroInteractionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiMicroInteraction {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    priority: !exists(json, 'priority') ? undefined : json['priority'],
    status: !exists(json, 'status') ? undefined : json['status'],
    comment: !exists(json, 'comment') ? undefined : json['comment'],
    isEligible: !exists(json, 'isEligible') ? undefined : json['isEligible'],
    apiStatus: !exists(json, 'apiStatus') ? undefined : json['apiStatus'],
    pet: !exists(json, 'pet') ? undefined : ApiMicroInteractionPetFromJSON(json['pet']),
    eligibility: !exists(json, 'eligibility')
      ? undefined
      : ApiMicroInteractionEligibilityFromJSON(json['eligibility']),
    event: !exists(json, 'event') ? undefined : ApiEventFromJSON(json['event']),
    steps: (json['steps'] as Array<any>).map(ApiMicroInteractionStepsInnerFromJSON),
    metadata: !exists(json, 'metadata') ? undefined : ApiMetadataFromJSON(json['metadata']),
  };
}

export function ApiMicroInteractionToJSON(value?: ApiMicroInteraction | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    priority: value.priority,
    status: value.status,
    comment: value.comment,
    isEligible: value.isEligible,
    apiStatus: value.apiStatus,
    pet: ApiMicroInteractionPetToJSON(value.pet),
    eligibility: ApiMicroInteractionEligibilityToJSON(value.eligibility),
    event: ApiEventToJSON(value.event),
    steps: (value.steps as Array<any>).map(ApiMicroInteractionStepsInnerToJSON),
    metadata: ApiMetadataToJSON(value.metadata),
  };
}
